@if (checkInsSummary()) {
  <div class="check-ins-summary">
    @for (c of checkInsSummaryFormatted(); track c.name) {
       <div class="check-ins-summary__item">
         <lib-icon [iconName]="c.statusIcon"></lib-icon>
         <span>{{ c.label }}</span>
       </div>
    }
  </div>
}
